import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  templateUrl: "./forbidden.component.html",
  styleUrls: ["./forbidden.component.scss"]
})
export class ForbiddenComponent {
  // Constructors
  constructor(private router: Router) {
  }

  // Public Methods
  public logout(): void {
    this.router.navigateByUrl('logout');
  }
}
